module.exports = __webpack_public_path__ + "service-marketing-email-blue.57d3362613bcbda58ac9.svg";